import * as actionTypes from "../actionTypes";
import {
	customDatePickerApiDateFormat,
	customDatePickerDateFormat,
} from "../components/CustomDatePicker";
import createReducer from "../lib/createReducer";
import dayjs from "dayjs";

const defaultExpandedRowKeys = Array.from({ length: 50 }, (_, index) => index);

export const defaultState = {
	optOutPageFilters: {
		// Api filters:
		pageTitle: "Opt-Outs",
		patentNumber: [],
		optOutType: ["WITHDRAW", "WITHDRAWAL_OF_OO_5_9", "REMOVAL_OPTOUT"],
		patentClassification: [],
		filingParty: [],
		applicants: [],
		allActiveFilters: [
			{ type: "optOutType", label: "Withdrawal - RoP 5.7", keys: false },
			{ type: "optOutType", label: "Withdrawal - RoP 5.9", keys: false },
			{ type: "optOutType", label: "Removal of Opt-Out - RoP 5A", keys: false },
		],
		dateRange: [],
		apiDirection: "lodging_time DESC",
		sortDirectionKey: "lodging_time",
		sortDirection: "DESC",
		sortedColumnDirection: "descend",
		currentPage: 1,
		limit: 50,
		expandedRowKeys: defaultExpandedRowKeys,
		// Page Settings:
		contentType: "List",
		tableVisibleColumns: ["Lodging Date", "Applicant", "Patent Number", "Type"],
		listVisibleColumns: [
			"Lodging Date",
			"Applicant",
			"Filing Party",
			"Patent Number",
			"Patent Name",
			"Patent Classification",
			"Type",
			"Related Patents",
		],
	},
	litigatedPatentsPageFilters: {
		// Api filters:
		pageTitle: "Litigated Patents",
		filingParties: [],
		litigantFirmsValues: [],
		litigantFirmsLabels: [],
		litigantAttorneysValues: [],
		litigantAttorneysLabels: [],
		patentClassification: [],
		patentNumber: [],
		apiDirection: "patent_number ASC",
		sortDirectionKey: "patent_number",
		sortDirection: "DESC",
		sortedColumnDirection: "descend",
		currentPage: 1,
		allActiveFilters: [],
		limit: 50,
		expandedRowKeys: defaultExpandedRowKeys,
		// Page Settings:
		contentType: "List",
		tableVisibleColumns: [
			"Patent Number",
			"Patentee",
			"Patent Classification",
			"Proceedings",
			"Patent Name",
			"Publication Date",
			"Applicants",
			"Abstract",
			"Related Patents",
			"US Litigated Patents",
		],
		listVisibleColumns: [
			"Patent Number",
			"Patentee",
			"Patent Classification",
			"Proceedings",
			"Patent Name",
			"Publication Date",
			"Applicants",
			"Abstract",
			"Related Patents",
			"US Litigated Patents",
		],
	},
	ordersPageFilters: {
		// Api filters:
		resultsValues: [],
		resultsLabels: [],
		firmsValues: [],
		firmsLabels: [],
		attorneysValues: [],
		attorneysLabels: [],
		patentNumber: [],
		pageTitle: "Decisions & Orders",
		party: "",
		selectedParties: [],
		court: [],
		judge: [],
		proceedingType: [],
		proceedingTypeLabels: [],
		eventType: [],
		eventTypeLabels: [],
		legalIssue: [],
		legalIssueLabels: [],
		patentClassification: [],
		patentClassificationLabels: [],
		caseNumber: "",
		selectedCaseNumbers: [],
		dateRange: [],
		apiDateRange: [],
		apiDirection: "document_filing_date DESC",
		sortDirectionKey: "document_filing_date",
		sortDirection: "DESC",
		sortedColumnDirection: "descend",
		currentPage: 1,
		allActiveFilters: [],
		limit: 50,
		expandedRowKeys: defaultExpandedRowKeys,
		// Page Settings:
		contentType: "List",
		tableVisibleColumns: [
			"Order Date",
			"Case Name",
			"Type of Event",
			"Result",
			"Orders",
			"Judge Name",
			"Court",
			"Case Number",
			"Case Filing Date",
			"Type of Proceeding",
			"Patents",
			"Legal Issue",
			"Annotation",
			"Party",
			"Firm",
			"Attorney",
			// Patent Classification Todo add when available
		],
		listVisibleColumns: [
			"Order Date",
			"Case Name",
			"Type of Event",
			"Result",
			"Orders",
			"Judge Name",
			"Court",
			"Case Number",
			"Case Filing Date",
			"Type of Proceeding",
			"Patents",
			"Legal Issue",
			"Annotation",
			"Party",
			"Firm",
			"Attorney",
			// Patent Classification Todo add when available
		],
	},
	iAMNewsArchivePageFilters: {
		partyDropdownSelectedValues: [],
		partyDropdownSearchValue: "",

		firmDropdownSelectedValues: [],
		firmDropdownSearchValue: "",

		attorneyDropdownSelectedValues: [],
		attorneyDropdownSearchValue: "",

		courtDropdownSelectedValues: [],
		courtDropdownSearchValue: "",

		patentDropdownSelectedValues: [],
		patentDropdownSearchValue: "",

		query: "",
		currentPage: 1,
	},
};

const UPC_UPDATE_LITIGATED_PATENTS_FILTERS = (state, action) => {
	const { filters } = action;
	return {
		...state,
		litigatedPatentsPageFilters: filters,
	};
};

const UPC_UPDATE_OPT_OUT_FILTERS = (state, action) => {
	const { filters } = action;
	return {
		...state,
		optOutPageFilters: filters,
	};
};

const UPC_UPDATE_ORDERS_FILTERS = (state, action) => {
	const { filters } = action;
	return {
		...state,
		ordersPageFilters: filters,
	};
};

const UPC_UPDATE_IAM_NEWS_ARCHIVE_FILTERS = (state, action) => {
	const { filters } = action;
	return {
		...state,
		iAMNewsArchivePageFilters: filters,
	};
};

const handlers = {};
handlers[actionTypes.UPC_UPDATE_LITIGATED_PATENTS_FILTERS] = UPC_UPDATE_LITIGATED_PATENTS_FILTERS;
handlers[actionTypes.UPC_UPDATE_OPT_OUT_FILTERS] = UPC_UPDATE_OPT_OUT_FILTERS;
handlers[actionTypes.UPC_UPDATE_ORDERS_FILTERS] = UPC_UPDATE_ORDERS_FILTERS;
handlers[actionTypes.UPC_UPDATE_IAM_NEWS_ARCHIVE_FILTERS] = UPC_UPDATE_IAM_NEWS_ARCHIVE_FILTERS;
export default createReducer(defaultState, handlers);
